// extracted by mini-css-extract-plugin
export var bcorp = "styles-module--bcorp--6fbce";
export var newsletter = "styles-module--newsletter--dd474";
export var newsletterSubmit = "styles-module--newsletterSubmit--ff6da";